var map = {
	"./10_of_Clubs.svg.png": "ec49",
	"./10_of_Diamonds.svg.png": "9fd4",
	"./10_of_Hearts.svg.png": "fb53",
	"./10_of_Spades.svg.png": "c43b",
	"./11_of_Clubs.svg.png": "0e18",
	"./11_of_Diamonds.svg.png": "40e4",
	"./11_of_Hearts.svg.png": "2f49",
	"./11_of_Spades.svg.png": "8073",
	"./12_of_Clubs.svg.png": "74a2",
	"./12_of_Diamonds.svg.png": "c0a4",
	"./12_of_Hearts.svg.png": "aed8",
	"./12_of_Spades.svg.png": "68e0",
	"./13_of_Clubs.svg.png": "b5bb",
	"./13_of_Diamonds.svg.png": "546b",
	"./13_of_Hearts.svg.png": "9a29",
	"./13_of_Spades.svg.png": "c125",
	"./1_of_Clubs.svg.png": "6d00",
	"./1_of_Diamonds.svg.png": "1198",
	"./1_of_Hearts.svg.png": "137b",
	"./1_of_Spades.svg.png": "1432",
	"./2_of_Clubs.svg.png": "c053",
	"./2_of_Diamonds.svg.png": "bd77",
	"./2_of_Hearts.svg.png": "ff67",
	"./2_of_Spades.svg.png": "208a",
	"./3_of_Clubs.svg.png": "550c",
	"./3_of_Diamonds.svg.png": "7aa7",
	"./3_of_Hearts.svg.png": "931a",
	"./3_of_Spades.svg.png": "276f",
	"./4_of_Clubs.svg.png": "e673",
	"./4_of_Diamonds.svg.png": "23ca",
	"./4_of_Hearts.svg.png": "6001",
	"./4_of_Spades.svg.png": "09a4",
	"./5_of_Clubs.svg.png": "6d0b",
	"./5_of_Diamonds.svg.png": "da27",
	"./5_of_Hearts.svg.png": "7916",
	"./5_of_Spades.svg.png": "ec0a",
	"./6_of_Clubs.svg.png": "e62e",
	"./6_of_Diamonds.svg.png": "6d55",
	"./6_of_Hearts.svg.png": "70e3",
	"./6_of_Spades.svg.png": "b1e9",
	"./7_of_Clubs.svg.png": "45ce",
	"./7_of_Diamonds.svg.png": "3ce6",
	"./7_of_Hearts.svg.png": "ada8",
	"./7_of_Spades.svg.png": "e49b",
	"./8_of_Clubs.svg.png": "3be6",
	"./8_of_Diamonds.svg.png": "5b29",
	"./8_of_Hearts.svg.png": "3c76",
	"./8_of_Spades.svg.png": "267e",
	"./9_of_Clubs.svg.png": "0186",
	"./9_of_Diamonds.svg.png": "d5a6",
	"./9_of_Hearts.svg.png": "ff5a",
	"./9_of_Spades.svg.png": "8f9b",
	"./Black_joker.svg.png": "d1db",
	"./Card_back.svg.png": "3d52",
	"./Red_joker.svg.png": "ace5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1865";